import type { Chain } from "./queries"

export function getChainRpcUrls(chain: Chain): string[] {
  const rpcUrls: string[] = []

  // Add public RPC URL
  if (chain.rpcUrlPublic) {
    rpcUrls.push(chain.rpcUrlPublic)
  }

  // Add primary RPC URL
  if (chain.rpcUrl) {
    rpcUrls.push(chain.rpcUrl)
  }

  return rpcUrls
}
